/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Closedeal_Summary_Finalraise3Inputs */

const en_coinvestments_closedeal_summary_finalraise3 = /** @type {(inputs: Coinvestments_Closedeal_Summary_Finalraise3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Final raise to date`)
};

/**
* | output |
* | --- |
* | "Final raise to date" |
*
* @param {Coinvestments_Closedeal_Summary_Finalraise3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_closedeal_summary_finalraise3 = /** @type {((inputs?: Coinvestments_Closedeal_Summary_Finalraise3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Closedeal_Summary_Finalraise3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_closedeal_summary_finalraise3(inputs)
});
export { coinvestments_closedeal_summary_finalraise3 as "coInvestments_closeDeal_summary_finalRaise" }